<template>
  <v-container>
    <v-row dense align="center" justify="space-between">
      <v-col cols="auto">
        <v-btn icon @click="$router.go(-1)">
          <v-icon>mdi-arrow-left</v-icon>
        </v-btn>
      </v-col>
      <v-col class="text-center">
        <div
          class="text-h4 font-weight-bold text-center"
          style="font-size: clamp(26px, 5vw, 36px); margin-bottom: 12px"
        >
          🦐 Producción y Venta Acuícola
        </div>
      </v-col>
      <v-col cols="12" class="pb-3">
        <div class="text-h6">1. Agrega una nueva Siembra</div>
        <div class="text-h7">
          Presiona el botón para agregar la producción de un estanque
        </div>
      </v-col>
      <v-col v-if="user_can.add" cols="12">
        <v-btn router to="/ru/acuicultura" depressed class="primary">
          <span style="font-size: 30px">🐟</span>
          <v-icon left>mdi-plus</v-icon>
          Agrega una nueva
        </v-btn>
      </v-col>

      <v-col cols="12" class="tt">
        <div class="text-h6">2. Mis Cosechas y Ventas</div>
        <div class="text-h8">
          Presiona la producción del Estanque para agregar Ventas o cosechas o modificarlas
        </div>
      </v-col>
      <!-- Fila de espaciado -->
      <v-col cols="12" class="py-5"></v-col>
      <!-- Puedes ajustar py-5 a py-3 o py-2 según el espacio que prefieras -->
      <!-- Mensaje si no hay fincas -->

      <v-col v-if="Object.keys(registros).length === 0" cols="12">
        <div class="text-body-1 text-center font-italic">
          Aún no tienes ninguna producción acuícola
        </div>
      </v-col>
      <!-- listado de actividades acuícolas en el almacenamiento local -->
      <v-col cols="12" class="lista">
        <v-list three-line>
          <template v-for="registro in registros">
            <form-card
              :key="registro.id"
              :top-text="'Finca • ' + getNombreDeFinca(registro.id_finca)"
              :top-right-text="registro.fecha"
              :middle-text="'Estanque ' + estanqueDescription(registro.parcela)"
              :bottom-text="`Ciclo ${registro.ciclo}`"
              :bottom-right-text="producerDescription(registro.productor)"
              :sincronized="registro.sincronizado"
              :opaque="registro.hasOutdatedRecords"
              @click="traerRegistroYNavegar(registro)"
            />
          </template>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { producerDescription, estanqueDescription } from '@/utilidades'

export default {
  name: 'Acuiculturas',
  computed: {
    ...mapState('registros', {
      registros: 'acuiculturas',
      fincas: 'fincas',
    }),

    ...mapGetters('registros', ['getNombreDeFinca']),

    user_can() {
      return this.$store.getters['auth/userCan'](this.$route.path)
    },
  },
  mounted() {
    this.$store.commit('ui/updateToolbar', 'Acuiculturas')
  },
  methods: {
    producerDescription,
    estanqueDescription,

    async traerRegistroYNavegar(registro) {
      if (registro.sincronizado === true) {
        await this.$store.dispatch('registros/getAcuicultura', {
          id: registro.id,
        })
      }
      this.$router.push(`/ru/acuicultura/${registro.id}`)
    },
  },
}
</script>
<style>
.tt {
  margin-top: 40px;
  margin-bottom: -20px;
}
.lista {
  margin-top: 20px;
}
</style>
